var invia = invia || {};

$(document).ready(function () {
	$('select[name="nl_payment_type_id"]').change(changedDeliveryOrPayment);
	$('input[name="nl_delivery_id"]').change(changedDeliveryOrPayment);
	changedDeliveryOrPayment();

	//vianocny odpocet
	//window.setInterval(countDown, 1000);
});

$(document).ready(function() {
	var certForm = $('#certificate_order_form');

	invia.initOrderAccountSettings('#s_login_type');

	certForm.submit(function(e) {
        if (e?.detail?.csrfEvent) {
            return;
        }

        // we want the CSRF protection being handled on submit
        certForm.get(0).dispatchEvent(new CustomEvent('submit', { bubbles: true, cancelable: true, detail: { csrfEvent: true } }));

		$.ajax({
			url: certForm.attr('action'),
			data: certForm.serialize(),
			dataType: 'json',
			success: function(data) {
				$('#user-messages').html('');
				certForm.find('.reset').remove();
				certForm.find('.invia-form-element.int-error').removeClass('int-error');

				// jsou nejake chyby na formu - vypiseme
				if (data.formErrors && Object.keys(data.formErrors).length > 0) {
					$.each(data.formErrors, function(elemName, errors) {
						var listItems = '';

						$.each(errors, function(j, msg) {
							listItems += '<li>' + msg + '</li>';
						});

						var list = '<ul class="reset int-info">' + listItems + '</ul>';

						$('[name="'+ elemName +'"]').closest('.invia-form-element')
							.append(list)
							.addClass('int-error');
					});

					try {
						$('html, body').animate({'scrollTop': $('.invia-form-element.int-error').first().offset().top - 100}, 500);
					} catch (err) {
						invia.Console.error(err);
					}
				}

				// nejaka chyba -> userMessage
				if (data.userErrorMessage) {
					$('#user-messages').html(invia.UserMessages.createMessage(invia.UserMessages.SEVERITY_ERROR, data.userErrorMessage));

					try {
						$('html, body').animate({'scrollTop': $('#user-messages').offset().top - 100}, 500);
					} catch (err) {
						invia.Console.error(err);
					}
				}

				if (data.redirectUrl) {
					window.location = data.redirectUrl;
				}
			},
			beforeSend: invia.showAjaxLoader,
			complete: invia.hideAjaxLoader,
			error: function(jqXHR, textStatus, errorThrown) {
				invia.Console.captureAjaxError(jqXHR, textStatus, errorThrown, this);
				alert('error');
			},
		});

		return false;
	});
});

function countDown()
{
	var $wrap = $('.count-down');
	var days = $wrap.find('#day').text();
	var hours = $wrap.find('#hour').text();
	var minutes = $wrap.find('#minute').text();
	var seconds = $wrap.find('#second').text();

	if (seconds > 0 || minutes > 0 || hours > 0 || days > 0)
	{
		if (seconds > 0) {
			seconds = seconds - 1;
		}
		else {
			seconds = 59;
			if (minutes > 0) {
				minutes = minutes - 1;
			}
			else {
				minutes = 59;
				if (hours > 0) {
					hours = hours - 1;
				}
				else {
					hours = 23;
					if (days > 0) {
						days = days - 1;
					}
				}
			}
		}
	}

	$wrap.find('#day').text(days);
	$wrap.find('#hour').text(hours);
	$wrap.find('#minute').text(minutes);
	$wrap.find('#second').text(seconds);
}

function changedDeliveryOrPayment()
{
	var pay_val = $('select[name="nl_payment_type_id"]').val();
	switch (pay_val)
	{
		case 3: // invoice (faktura)
		case '3': // invoice (faktura)
			$('.pay-online').hide();
			$('.pay-offline').show();
			$('.pay-company').show();
			break;
		case 5: //cs - ceska sporitelna
		case '5': //cs - ceska sporitelna
		case 6: // platba24 - ceska sporitelna
		case '6': // platba24 - ceska sporitelna
			$('.pay-company').hide();
			$('.pay-offline').hide();
			$('.pay-online').show();
			break;
		case 1: // wire (prevod)
		case '1': // wire (prevod)
		case 2: // cash
		case '2': // cash
		default:
			$('.pay-company').hide();
			$('.pay-online').hide();
			$('.pay-offline').show();
	}

	var delivery_val = $('input[name="nl_delivery_id"]:checked').val();
	switch (delivery_val)
	{
		case 1 : // snail post
		case '1' : // snail post
			$('.delivery-post').show();
			$('.delivery-personal').hide();
			$('.nl_payment_type_id [rel="9"]').show();
			break;
		case 8 : // personal
		case '8' : // personal
			$('.delivery-personal').show();
			$('.delivery-post').hide();
			$('.nl_payment_type_id [rel="9"]').hide();
			break;
		case 2 : // email
		case '2' : // email
		default :
			$('.delivery-post').hide();
			$('.delivery-personal').hide();
			$('.nl_payment_type_id [rel="9"]').show();
	}
}
